import { Component, Inject, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MatSnackBar, MatDialogRef, MAT_DIALOG_DATA  } from '@angular/material';
import { ClipBoardService } from 'src/app/services/clipboard.service';
import { ServerService } from 'src/app/services/server.service';

@Component({
  selector: 'app-edit-caller-id-modal',
  templateUrl: './edit-caller-id-modal.component.html',
  styleUrls: ['./edit-caller-id-modal.component.scss']
})

export class EditCallerIdModalComponent implements OnInit {

  authToken = localStorage.getItem("token")

  public userInfo = JSON.parse(localStorage.getItem("userInfo"));

  btnStatus: boolean = false

  createCallerIdForm: FormGroup;

  isVendorAdmin: boolean = this.userInfo.member_type == "Vendor" ? true : false;

  callerIdData:any;

  constructor(
    private serverService: ServerService,
    private clipBoardService: ClipBoardService,
    private snackBar: MatSnackBar,
    private fb: FormBuilder,
    private dialogRef: MatDialogRef<EditCallerIdModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data
  ) {

    this.callerIdData = data;

    this.createCallerIdForm = this.fb.group({
      countryCode: ['+91', Validators.required],
      phone: ['', [ Validators.required, Validators.minLength(10), Validators.maxLength(10)] ],
      friendlyName: ['', Validators.required],
      //setAsDefault: [false],
    });

    this.createCallerIdForm.get('countryCode').patchValue('+91')
    this.createCallerIdForm.get('phone').patchValue(data.phone_number.slice(3))
    this.createCallerIdForm.get('friendlyName').patchValue(data.friendly_name)

  }

  ngOnInit() {

  }

  updateCallerId() {

    this.btnStatus = true;

    if (this.createCallerIdForm.invalid) {
      return false
    }

    let body = {
      // "countryCode": this.createCallerIdForm.value.countryCode,
      //"phone_number": this.createCallerIdForm.value.countryCode+this.createCallerIdForm.value.phone,
      "friendly_name": this.createCallerIdForm.value.friendlyName,
      // "setAsDefault": this.createCallerIdForm.value.setAsDefault,
    }

    this.serverService.updateCallerId(this.callerIdData.id, body, this.authToken).subscribe(data => {
      this.btnStatus = false;
      this.dialogRef.close(data);
      this.clipBoardService.showMessgeInText("Caller ID Update Succesfully", "success-snackbar");
    },
      err => {
        let message = JSON.parse(err._body);
        if (err.status == 422) {
          this.clipBoardService.showMessgeInText(JSON.stringify(message.errors), "error-snackbar");
        } else {
          this.clipBoardService.checkServerError(err, this.authToken)
        }
        this.btnStatus = false;
      }
    )

  }

  close() {
    this.dialogRef.close();
  }

}
